import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ComboObservacionesEyaculadoEliminado/editComboObservacionesEyaculadoEliminado`, method: 'POST', body: values, token: token})
}
